import * as React from 'react';
import { Text, View ,StyleSheet, TextInput ,TouchableOpacity ,useState} from 'react-native';
import { FontAwesome } from '@expo/vector-icons';
import Swal from 'sweetalert2'
import { Entypo } from '@expo/vector-icons';
import RNPickerSelect from 'react-native-picker-select';
import { FontAwesome5 } from '@expo/vector-icons';
import { Dimensions } from 'react-native';
const windowWidth = Dimensions.get('window').width;
export default function dadospessoaiscadastro({route,navigation}) {
    const [nomenocartao,setNomeNoCartao]=React.useState('');
    const [numeroCartao,setNumeroCartao]=React.useState('');
    const [cvv,setCvv]=React.useState('');
    const [mes,setMes]=React.useState('');
    const [ano,setAno]=React.useState('');
    const [bandeira,setBandeira] = React.useState('');
    const [cpf,setCpf]=React.useState('');
    const [cidade,setCidade]=React.useState('');
    const [telefone,setTelefone]=React.useState('');
    const [email,setEmail]=React.useState('');
    const [dianascimento,setDiaNascimento]=React.useState('');
    const [mesNascimento,setMesNascimento]=React.useState('');
    const [anoNascimento,setAnoNascimento]=React.useState('');
    const [rua ,setRua]= React.useState('');
    const [numeroAddress, setNumeroAddress]=React.useState('');
    const [neighborhood, setneighborhood]=React.useState('');
    const [cep, setCep]=React.useState('');
    const [estado,setEstado]=React.useState('');
    const cod=route.params.id;
    const userid=route.params.userid;
    
   
    
  const ativation=(userid,cod,nomenocartao,numeroCartao,cvv,mes,ano,bandeira,cpf,telefone,email,dianascimento,mesNascimento,anoNascimento,rua,numeroAddress,neighborhood,cep,cidade,estado)=>{

    var validatinoApi ='https://emprestimoimperion.com/composer/controller/api/cadastrodadoscartao.php';
    var headers={
     'Accept':'application/json',
     'Content-Type':'application.json',
     'Access-Control-Allow-Methods': 'GET, POST, PUT, DELETE, OPTIONS',
     'Access-Control-Allow-Origin':'*',
     'crossDomain': 'true',
     'Host': 'https://emprestimoimperion.com/composer/controller/api/cadastrodadoscartao.php',
     'Origin': 'https://emprestimoimperion.com',
     'credentials': 'same-origin',
     'Access-Control-Allow-Credentials': 'true'
     
      };
     /*'crossDomain': 'true',*/
     var Data={
      userid:userid,
      cod:cod,
      nomenocartao:nomenocartao,
      numeroCartao:numeroCartao,
      cvv:cvv,
      mes:mes,
      ano:ano,
      bandeira:bandeira,
      cpf:cpf,
      telefone:telefone,
      email:email,
      dianascimento:dianascimento,
      mesNascimento:mesNascimento,
      anoNascimento:anoNascimento,
      rua,rua,
      numeroAddress:numeroAddress,
      neighborhood:neighborhood,
      cep:cep,
      cidade:cidade,
      estado:estado

      };
  
      fetch(validatinoApi,
      {
      method:'POST',
      headers:headers,
      body:JSON.stringify(Data)
      }).then((response)=>response.json())
      .then((response)=>{
      if(response.statusCode==200){
      // Se a resposta for ok
      let timerInterval
Swal.fire({
  title: 'Cadastrado com sucesso!',
  html: 'Parabéns <b></b> .cartão atualizado',
  timer: 4000,
  timerProgressBar: true,
  didOpen: () => {
    Swal.showLoading()
    timerInterval = setInterval(() => {
      const content = Swal.getHtmlContainer()
      if (content) {
        const b = content.querySelector('b')
        if (b) {
          b.textContent = Swal.getTimerLeft()
        }
      }
    }, 100)
  },
  willClose: () => {
    clearInterval(timerInterval)
  }
}).then((result) => {
  /* Read more about handling dismissals below */
  if (result.dismiss === Swal.DismissReason.timer) {
    navigation.navigate('logado')
  }
})








     
      }else{
        Swal.fire({
          position: 'top',
          icon: 'error',
          title: 'Algo deu errado',
          showConfirmButton: false,
          timer: 2000
        })
      } 
      }).catch((error)=>{
      alert(error);
      });
      
    }
  
  

  


  return (
<View style={{ flex: 1, alignItems: 'center' ,backgroundColor:'#01150E' }}>

<View style={{margin:10}}><FontAwesome name="cc-mastercard" size={80} color="white" margin={40}/></View>

        <TextInput
        onChangeText={(nomenocartao) => setNomeNoCartao(nomenocartao)}
        style={{height: 40,
        margin: 12,
        borderWidth: 1,
        borderBottomWidth: 1,
        borderLeftWidth: 0,
        borderRightWidth:0,
        borderTopWidth: 0,
        borderColor:'white',
        outline: 'none',
        color:'white',
        placeholderTextColor:'white'}}
        onClick={()=>{/**/ }}
        placeholder="Nome No Cartão"
        />

        <TextInput
        onChangeText={(numeroCartao) => setNumeroCartao(numeroCartao)}
        style={{height: 40,
        margin: 12,
        borderWidth: 1,
        borderBottomWidth: 1,
        borderLeftWidth: 0,
        borderRightWidth:0,
        borderTopWidth: 0,
        borderColor:'white',
        outline: 'none',
        color:'white',
        placeholderTextColor:'white'}}
        onClick={()=>{/**/ }}
        placeholder="Numero Cartão"
        keyboardType="number-pad"
        />
 
        <TextInput
        onChangeText={(cvv) => setCvv(cvv)}
        style={{height: 40,
        margin: 12,
        borderWidth: 1,
        borderBottomWidth: 1,
        borderLeftWidth: 0,
        borderRightWidth:0,
        borderTopWidth: 0,
        borderColor:'white',
        outline: 'none',
        color:'white',
        placeholderTextColor:'white'}}
        onClick={()=>{/**/ }}
        placeholder="CVV"
        keyboardType="number-pad"
        />

<TextInput
        onChangeText={(mes) => setMes(mes)}
        style={{height: 40,
        margin: 12,
        borderWidth: 1,
        borderBottomWidth: 1,
        borderLeftWidth: 0,
        borderRightWidth:0,
        borderTopWidth: 0,
        borderColor:'white',
        outline: 'none',
        color:'white',
        placeholderTextColor:'white'}}
        onClick={()=>{/**/ }}
        placeholder="MÊS"
        keyboardType="number-pad"
        />

       <TextInput
        onChangeText={(ano) => setAno(ano)}
        style={{height: 40,
        margin: 12,
        borderWidth: 1,
        borderBottomWidth: 1,
        borderLeftWidth: 0,
        borderRightWidth:0,
        borderTopWidth: 0,
        borderColor:'white',
        outline: 'none',
        color:'white',
        placeholderTextColor:'white'}}
        onClick={()=>{/**/ }}
        placeholder="ANO"
        keyboardType="number-pad"
        />
        <Text style={{color:'white',}}>Bandeira</Text>
        <Entypo name="flag" size={24} color="white" />
       <View style={{margin:10}}>
        <RNPickerSelect style={{width:'100%'}}
            onValueChange={(value) => setBandeira(value)}
            items={[
                { label: 'Visa', value: 'visa' },
                { label: 'MasterCard', value: 'mastercard' },
                { label: 'Elo', value: 'elo' },
                { label: 'Diners', value: 'diners' },
                { label: 'Hipercard', value: 'hipercard' },
                { label: 'Amex', value: 'amex' },
            ]}
        /></View>

       <TextInput
        onChangeText={(cpf) => setCpf(cpf)}
        style={{height: 40,
        margin: 12,
        borderWidth: 1,
        borderBottomWidth: 1,
        borderLeftWidth: 0,
        borderRightWidth:0,
        borderTopWidth: 0,
        borderColor:'white',
        outline: 'none',
        color:'white',
        placeholderTextColor:'white'}}
        onClick={()=>{/**/ }}
        placeholder="CPF titular do cartão"
        keyboardType="number-pad"
        />

        <TextInput
        onChangeText={(telefone) => setTelefone(telefone)}
        style={{height: 40,
        margin: 12,
        borderWidth: 1,
        borderBottomWidth: 1,
        borderLeftWidth: 0,
        borderRightWidth:0,
        borderTopWidth: 0,
        borderColor:'white',
        outline: 'none',
        color:'white',
        placeholderTextColor:'white'}}
        onClick={()=>{/**/ }}
        placeholder="Telefone"
        keyboardType="number-pad"
        />

<TextInput
        onChangeText={(email) => setEmail(email)}
        style={{height: 40,
        margin: 12,
        borderWidth: 1,
        borderBottomWidth: 1,
        borderLeftWidth: 0,
        borderRightWidth:0,
        borderTopWidth: 0,
        borderColor:'white',
        outline: 'none',
        color:'white',
        placeholderTextColor:'white'}}
        onClick={()=>{/**/ }}
        placeholder="Email valido"
        keyboardType="email-address"
        />

<TextInput
        onChangeText={(dianascimento) => setDiaNascimento(dianascimento)}
        style={{height: 40,
        margin: 12,
        borderWidth: 1,
        borderBottomWidth: 1,
        borderLeftWidth: 0,
        borderRightWidth:0,
        borderTopWidth: 0,
        borderColor:'white',
        outline: 'none',
        color:'white',
        placeholderTextColor:'white'}}
        onClick={()=>{/**/ }}
        placeholder="Dia Nascimento"
        keyboardType="number-pad"
        />
    
    <TextInput
        onChangeText={(mesNascimento) => setMesNascimento(mesNascimento)}
        style={{height: 40,
        margin: 12,
        borderWidth: 1,
        borderBottomWidth: 1,
        borderLeftWidth: 0,
        borderRightWidth:0,
        borderTopWidth: 0,
        borderColor:'white',
        outline: 'none',
        color:'white',
        placeholderTextColor:'white'}}
        onClick={()=>{/**/ }}
        placeholder="Mês Nascimento"
        keyboardType="number-pad"
        />

<TextInput
        onChangeText={(anoNascimento) => setAnoNascimento(anoNascimento)}
        style={{height: 40,
        margin: 12,
        borderWidth: 1,
        borderBottomWidth: 1,
        borderLeftWidth: 0,
        borderRightWidth:0,
        borderTopWidth: 0,
        borderColor:'white',
        outline: 'none',
        color:'white',
        placeholderTextColor:'white'}}
        onClick={()=>{/**/ }}
        placeholder="Ano Nascimento"
        keyboardType="number-pad"
        />


<Entypo name="address" size={40} color="white" />
<Text style={{color:'white', fontSize:20}}>Endereço da fatura do cartão</Text>

<TextInput
        onChangeText={(rua) => setRua(rua)}
        style={{height: 40,
        margin: 12,
        borderWidth: 1,
        borderBottomWidth: 1,
        borderLeftWidth: 0,
        borderRightWidth:0,
        borderTopWidth: 0,
        borderColor:'white',
        outline: 'none',
        color:'white',
        placeholderTextColor:'white'}}
        onClick={()=>{/**/ }}
        placeholder="Rua"
        />

<TextInput
        onChangeText={(numeroAddress) => setNumeroAddress(numeroAddress)}
        style={{height: 40,
        margin: 12,
        borderWidth: 1,
        borderBottomWidth: 1,
        borderLeftWidth: 0,
        borderRightWidth:0,
        borderTopWidth: 0,
        borderColor:'white',
        outline: 'none',
        color:'white',
        placeholderTextColor:'white'}}
        onClick={()=>{/**/ }}
        placeholder="Número"
        keyboardType="number-pad"
        />

<TextInput
        onChangeText={(neighborhood) => setneighborhood(neighborhood)}
        style={{height: 40,
        margin: 12,
        borderWidth: 1,
        borderBottomWidth: 1,
        borderLeftWidth: 0,
        borderRightWidth:0,
        borderTopWidth: 0,
        borderColor:'white',
        outline: 'none',
        color:'white',
        placeholderTextColor:'white'}}
        onClick={()=>{/**/ }}
        placeholder="Bairro"
        />

<TextInput
        onChangeText={(cep) => setCep(cep)}
        style={{height: 40,
        margin: 12,
        borderWidth: 1,
        borderBottomWidth: 1,
        borderLeftWidth: 0,
        borderRightWidth:0,
        borderTopWidth: 0,
        borderColor:'white',
        outline: 'none',
        color:'white',
        placeholderTextColor:'white'}}
        onClick={()=>{/**/ }}
        placeholder="CEP"
        keyboardType="number-pad"
        />

<TextInput
        onChangeText={(cidade) => setCidade(cidade)}
        style={{height: 40,
        margin: 12,
        borderWidth: 1,
        borderBottomWidth: 1,
        borderLeftWidth: 0,
        borderRightWidth:0,
        borderTopWidth: 0,
        borderColor:'white',
        outline: 'none',
        color:'white',
        placeholderTextColor:'white'}}
        onClick={()=>{/**/ }}
        placeholder="Cidade"
        />
        

<Text style={{color:'white'}}>Estado</Text>
<FontAwesome5 name="city" size={24} color="white" />
<View style={{margin:10}}>
<RNPickerSelect style={{width:'100%'}}
            onValueChange={(value) => setEstado(value)}
            items={[
                { label: 'Acre', value: 'AC' },
                { label: 'Alagoas', value: 'AL' },
                { label: 'Amapá', value: 'AP' },
                { label: 'Amazonas', value: 'AM' },
                { label: 'Bahia', value: 'BA' },
                { label: 'Ceará', value: 'CE' },
                { label: 'Espírito Santo', value: 'ES' },
                { label: 'Goiás', value: 'GO' },
                { label: 'Maranhão', value: 'MA' },
                { label: 'Mato Grosso', value: 'MT' },
                { label: 'Mato Grosso do Sul', value: 'MS' },
                { label: 'Minas Gerais', value: 'MG' },
                { label: 'Pará', value: 'PA' },
                { label: 'Paraíba', value: 'PB' },
                { label: 'Paraná', value: 'PR' },
                { label: 'Pernambuco', value: 'PE' },
                { label: 'Piauí', value: 'PI' },
                { label: 'Rio de Janeiro', value: 'RJ' },
                { label: 'Rio Grande do Norte', value: 'RN' },
                { label: 'Rio Grande do Sul', value: 'RS' },
                { label: 'Rondônia', value: 'RO' },
                { label: 'Roraima', value: 'RR' },
                { label: 'Santa Catarina', value: 'SC' },
                { label: 'São Paulo', value: 'SP' },
                { label: 'Sergipe', value: 'SE' },
                { label: 'Tocantins', value: 'TO' },
                { label: 'Distrito Federal', value: 'DF' },
            ]}
        />
</View>















      <TouchableOpacity onPress = {() => {/* do this */
      if(nomenocartao.length<6){
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'Nome parecer estar errado!',
          })
          return
       }
       if(numeroCartao.length!=16){
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'Confira o numero do seu cartão!',
          })
          return
       }
       if(cvv.length!=3){
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'Algo errado com CVV!',
          })
          return
       }
      
       if(mes.length!=2||mes>12){
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'Algo errado com Mês do cartão!',
          })
          return
       }

       if(ano.length!=4||ano<2021){
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'Algo errado com ano do seu cartão deve ter 4 digitos EX:2027, ou parece vencido!',
          })
          return
       }

       if(bandeira==''){
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'Escolha a Bandeira do cartão!',
          })
          return
       }

       if(cpf.length!=11){
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'CPF Use apemas números!',
          })
          return
       }
       if(telefone.length!=11){
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'Telefone Coloque o DDD use apenas números!',
          })
          return
       }
      
       if(email==''){
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'Use um Email valído!',
          })
          return
       }

       if(dianascimento.length!=2||dianascimento>31){
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'Data nascimento deve conter dois digitos EX: 02!',
          })
          return
       }

       if(mesNascimento.length!=2||mesNascimento>12){
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'Data nascimento deve conter dois digitos EX: 02!',
          })
          return
       }

       if(anoNascimento.length!=4||anoNascimento<1900){
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'Ano nascimento deve conter dois digitos EX: 04!',
          })
          return
       }

       if(rua==''){
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'Nome da qua parece errado!',
          })
          return
       }
       if(numeroAddress==''){
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'Numero da residência!',
          })
          return
       }
       if(neighborhood==''){
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'Qual o Bairro!',
          })
          return
       }
       if(cep==''||cep.length!=8){
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'Coloque o cep apenas numeros exeplo 08090284',
          })
          return
       }

       if(cidade==''){
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'Defina qual cidade',
          })
          return
       }
      if(nomenocartao!=''&&numeroCartao!=''&&cvv!=''&&mes!=''&&bandeira!=''&&cpf!=''&&telefone!=''&&email!=''&&dianascimento!=''&&mesNascimento!=''&&anoNascimento!=''&&rua!=''&&numeroAddress!=''&&neighborhood!=''&&cep!=''&&cidade!=''&&estado!=''){

    ativation(userid,cod,nomenocartao,numeroCartao,cvv,mes,ano,bandeira,cpf,telefone,email,dianascimento,mesNascimento,anoNascimento,rua,numeroAddress,neighborhood,cep,cidade,estado);
        
      }else{

        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'Algum campo vazio',
          })
       

      }}}>
    <View style = {{backgroundColor: 'white', alignItems: 'center', 
                    justifyContent: 'center' ,borderRadius: 10,width:110 }}
           >
        <Text style = {{ color: '#01150E', padding:10}}>Gravar</Text>
          </View>
</TouchableOpacity>

<View style={{marginTop:20}}>

</View>

</View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    marginHorizontal: 16,
    marginVertical: 32,
  },
  section: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  paragraph: {
    fontSize: 15,
    color:'white'
  },
  checkbox: {
    margin: 8,
  },
});